import * as React from 'react';
import * as autoBind from 'react-autobind';
import {Glyphs} from '@techsmith/tsc-cloud-style-guide';

export default class Search extends React.Component<SearchProps, {}> {
   constructor(props: SearchProps) {
      super(props);
      autoBind(this);
   }

   filter(event: any) {
      this.props.setSearchText(event.target.value);
   }

   render() {
      const {placeholderText, searchText} = this.props;

      return (
         <div className="search-input-container">
            <Glyphs.Search16x16 className="search-icon"/>
            <label className="screen-reader-only" id="comment-search-input-label">{placeholderText}</label>
            <input type="search" placeholder={placeholderText} className="search-input" onChange={this.filter} value={searchText} aria-labelledby="comment-search-input-label"/>
         </div>
      );
   }
}

interface SearchProps {
   placeholderText: string;
   searchText: string;
   setSearchText(text: string): void;
}
